import React from "react";

import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router-dom";

import Heading from "@atlaskit/heading";
import Link from "@atlaskit/link";
import { Stack, Text, xcss } from "@atlaskit/primitives-next";
import Skeleton from "@atlaskit/skeleton";

import { messages } from "./messages";

interface SummarySectionCardProps {
    title: string;
    value: number;
    isLoading: boolean;
    error: string | null;
}

const containerStyle = xcss({
    borderRadius: "border.radius.200",
    borderColor: "color.border",
    borderWidth: "border.width",
    borderStyle: "solid",
    padding: "space.200"
});

export const SummarySectionCard: React.FC<SummarySectionCardProps> = ({
    title,
    value,
    isLoading,
    error
}) => {
    const { pathname } = useLocation();

    if (isLoading) {
        return (
            <Stack
                xcss={containerStyle}
                grow="fill"
                alignBlock="center"
                space="space.075"
            >
                <Skeleton height="12px" width="100%" />
                <Skeleton height="20px" width="100%" />
            </Stack>
        );
    }

    if (error) {
        return (
            <Stack
                xcss={containerStyle}
                grow="fill"
                alignBlock="center"
                alignInline="center"
                space="space.075"
            >
                <Heading size="small">
                    <FormattedMessage {...messages.errorHeading} />
                </Heading>
                <Link href={pathname}>
                    <Text size="small" color="color.link">
                        <FormattedMessage {...messages.refreshPage} />
                    </Text>
                </Link>
            </Stack>
        );
    }

    return (
        <Stack
            xcss={containerStyle}
            grow="fill"
            alignBlock="center"
            space="space.075"
        >
            <Heading size="xxsmall">{title}</Heading>
            <Heading size="medium">{value}</Heading>
        </Stack>
    );
};
